import { GetterTree } from 'vuex';
import { RallyIntelligenceState, RootState } from '../types';

export const getters: GetterTree<RallyIntelligenceState, RootState> = {
	creditsRemaining(state): number {
		return state.creditsRemaining;
	},
	creditsExhausted(state): boolean {
		return state.creditsRemaining <= 0;
	}
};
